/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-unused-state */
import React from 'react';
import { Trans } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalDialog from '../../../components/modal/ModalDialog';
import ModalService from '../../../logic/services/ModalService';
import { AppIcon } from '../../../index';
import NoImage from '../../../assets/no-image.png';
import TransactionMap from '../components/TransactionMap';
import TransactionModel from '../models/TransactionModel';

const InfoItem = ({ title, content, link }) => {
  const safeContent =
    typeof content === 'string' ? content.replace(/_/g, ' ') : content;

  return (
    <div className="d-flex flex-row flex-md-row align-items-center justify-content-center w-100 pb-1">
      <div className="w-50 text-left text-md-left text-wrap text-break">
        <span className="text-center text-md-left">
          <Trans>{title.replace(/_/g, ' ')}</Trans>
        </span>
      </div>
      <div className="w-100 text-right text-md-right text-wrap text-break">
        {link || (
          <span className="text-right text-md-right">
            <Trans>{safeContent}</Trans>
          </span>
        )}
      </div>
    </div>
  );
};

export default class MerchantInfoModal extends React.PureComponent {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    // Initial state
    this.state = {
      merchantInfo: null,
      loading: true
    };
  }

  componentDidMount() {
    this._getMerchantDetails();
  }

  // eslint-disable-next-line consistent-return
  async _getMerchantDetails() {
    const { id } = this.props;
    try {
      const merchantDetails = await new TransactionModel().getMerchantDetails(
        id
      );

      this.setState(
        {
          merchantInfo: merchantDetails
        },
        () => {
          this.setState({
            loading: false
          });
        }
      );
    } catch (err) {
      console.log(err);
      this.setState({
        loading: false
      });
    }
  }

  render() {
    const { merchantInfo } = this.state;

    let logo = NoImage;

    if (
      merchantInfo &&
      merchantInfo?.image &&
      merchantInfo?.image !== 'not_found'
    ) {
      logo = merchantInfo?.image;
    } else if (
      merchantInfo &&
      merchantInfo?.visual_enrichments &&
      merchantInfo?.visual_enrichments?.merchant_logo_link &&
      merchantInfo?.visual_enrichments?.merchant_logo_link !== 'not_found'
    ) {
      logo = merchantInfo?.visual_enrichments?.merchant_logo_link;
    }

    const infoLines = [
      merchantInfo?.visual_enrichments?.merchant_clean_name,
      merchantInfo?.merchant_location?.address?.street,
      merchantInfo?.merchant_location?.address?.zip_code,
      merchantInfo?.merchant_location?.address?.city,
      merchantInfo?.merchant_location?.address?.country
    ];

    return (
      <ModalDialog id="MERCHANT_INFO" show>
        <div className="transaction-modal">
          <div className="close-btn">
            <AppIcon
              name="fa.times"
              style={{
                fontSize: 24,
                cursor: 'pointer'
              }}
              onClick={() => ModalService.hideModal('MERCHANT_INFO')}
            />
          </div>
          {this.state.loading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ flex: 1 }}
            >
              <CircularProgress className="circle-progress" size={20} />
            </div>
          ) : (
            <div
              className="d-flex flex-column align-items-center justify-content-start w-100 mt-10"
              style={{
                minHeight: 450,
                flex: 1
              }}
            >
              {!merchantInfo || merchantInfo?.length === 0 ? (
                <span>
                  <Trans>
                    Sorry, we currently have no information about the merchant.
                  </Trans>
                </span>
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center w-100">
                  <img
                    src={logo}
                    alt="merchant-logo"
                    style={{
                      width: 80,
                      height: 80,
                      marginBottom: 10,
                      borderRadius: '50%'
                    }}
                  />

                  <InfoItem
                    title="Name:"
                    content={
                      merchantInfo?.visual_enrichments?.merchant_clean_name ||
                      'not found'
                    }
                  />
                  <InfoItem
                    title="Merchant category:"
                    content={
                      merchantInfo?.categories?.length
                        ? `${merchantInfo?.categories[0]?.name || ''}${
                            merchantInfo?.categories[1]
                              ? ` - ${merchantInfo?.categories[1]?.name}`
                              : ''
                          }`
                        : 'not found'
                    }
                  />
                  <h4 className="my-2">Contact</h4>
                  <InfoItem
                    title="Email:"
                    content={merchantInfo?.contact?.email || 'not found'}
                  />
                  <InfoItem
                    title="Phone:"
                    content={merchantInfo?.contact?.phone || 'not found'}
                  />
                  <InfoItem
                    title="Website:"
                    link={
                      merchantInfo.contact?.websiteUrl ||
                      merchantInfo?.contact?.website ? (
                        <a
                          target="_blank"
                          href={
                            merchantInfo.contact?.websiteUrl ||
                            merchantInfo?.contact?.website
                          }
                        >
                          {merchantInfo.contact?.websiteUrl ||
                            merchantInfo?.contact?.website}
                        </a>
                      ) : (
                        'not found'
                      )
                    }
                  />

                  <h4 className="my-2">Location</h4>
                  <InfoItem
                    title="Street:"
                    content={
                      merchantInfo?.merchant_location?.address?.street ||
                      'not found'
                    }
                  />
                  <InfoItem
                    title="Postal Code:"
                    content={
                      merchantInfo?.merchant_location?.address?.zip_code ||
                      'not found'
                    }
                  />
                  <InfoItem
                    title="City:"
                    content={
                      merchantInfo?.merchant_location?.address?.city ||
                      'not found'
                    }
                  />
                  <InfoItem
                    title="Country:"
                    content={
                      merchantInfo?.merchant_location?.address?.country ||
                      'not found'
                    }
                  />
                  {merchantInfo?.merchant_location?.coordinates?.lat &&
                    merchantInfo?.merchant_location?.coordinates?.lat !==
                      'not_found' &&
                    merchantInfo?.merchant_location?.coordinates?.lon &&
                    merchantInfo?.merchant_location?.coordinates?.lon !==
                      'not_found' && (
                      <TransactionMap
                        latitude={
                          merchantInfo?.merchant_location?.coordinates?.lat
                        }
                        longitude={
                          merchantInfo?.merchant_location?.coordinates?.lon
                        }
                        infoLines={infoLines}
                      />
                    )}
                </div>
              )}
            </div>
          )}
        </div>
      </ModalDialog>
    );
  }
}
